import { Pencil } from 'lucide-react';
import React from 'react';
import { useSelector } from 'react-redux';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';

const prepareDataCulture = (data) => {
  if (!data) return [];
  const { biblio, title, mark, description } = data;
  return [
    { name: 'Biblio', value: biblio?.title },
    { name: 'Název', value: title },
    { name: 'Značka', value: mark },
    { name: 'Popisek', value: description },
  ];
};

export default function UnitsDetailView({ data, editUnit }) {
  const permission = useSelector((state) => (state.auth as any).pagePermission);

  return (
    <div>
      <Bar
        text="Jednotka"
        content={
          permission === 2
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={() => editUnit()}
                  data-testid="units-detail-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions objectType="unit" objectId={data?.id} status={data?.status} />
      <List data={prepareDataCulture(data)} />

      {/* <UnitCultureModal
        visible={actualCultureVisible}
        title={getActualCulture?.culture?.title}
        onClose={() => setActualCultureVisible(false)}
      /> */}
    </div>
  );
}
